
import { defineComponent } from "vue";
export default defineComponent({
  inheritAttrs: false,
  name: "VInput",
  data() {
    return {
      showPassword: false,
    };
  },
  props: {
    value: {
      required: false,
    },
    type: {
      type: String,
      default: "text",
    },
    className: {
      type: [String, Array, Object],
      required: false,
    },
    containerClassName: {
      type: [String, Array, Object],
      required: false,
    },
    showHideIcon: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      required: false,
    },
  },

  model: {
    prop: "value",
    event: "update",
  },
  methods: {
    update(event: Event): void {
      this.$emit("update", (event.target as HTMLInputElement).value);
    },
    togglePassword(): void {
      this.showPassword = !this.showPassword;
    },
  },
});
